<template>
  <div class="sn-f-b-s record">
    <sn-navigator id="YYJL"></sn-navigator>
    <div class="sn-f-1 sn-f-s-1 sn-f-col-b-s record-region">
      <sn-breadcrumb :breadcrumb="[{
        title: '挂号预约记录'
      }]"></sn-breadcrumb>
      <div class="sn-f-1 sn-f-s-1 record-blank">
        <div class="sn-table" v-if="!$sn.validate.empty(handleRecord)">
          <table>
            <thead>
              <tr>
                <th>序号</th>
                <th>患者姓名</th>
                <th>专家姓名</th>
                <th v-if="isShowScheduleCostAppointment">{{ $sn.getConfig('costContentTitle') }}</th>
                <th>预约科室</th>
                <th>预约时间</th>
                <th>预约状态</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr :key="record.appointId" v-for="(record, i) in handleRecord">
                <td>{{ i + 1 }}</td>
                <td>{{ $sn.encrypted.name(record.patientName) }}</td>
                <td>{{ record.doctorName }}</td>
                <td v-if="isShowScheduleCostAppointment">{{ record.regFee }}元</td>
                <td>{{ record.deptName }}</td>
                <td>
                  {{ record.schDate }}&nbsp;&nbsp;{{ record.schTime }}
                  <template v-if="record.schSeq &&
                  ((isShowTimeSerialOnAppointmentRecord === 1 && parseFloat(record.schSeq) >= 0) ||
                  (isShowTimeSerialOnAppointmentRecord === 2 && record.state === 1 && parseFloat(record.schSeq) >= 0) ||
                  (isShowTimeSerialOnAppointmentRecord === 4 && record.state === 1))">
                    &nbsp;&nbsp;[{{ record.schSeq }}]
                  </template>
                </td>
                <td :class="handlePattern(record)" v-html="handleStatus(record)"></td>
                <td class="sn-pointer sn-fc-main" @click="appointment_mixin_navigateUrl('/appointment/record-info', record);">查看详情</td>
              </tr>
            </tbody>
          </table>
        </div>
        <sn-no-data v-else></sn-no-data>
      </div>
      <div class="sn-f-s-0 sn-f-e-c pagination">
        <div class="sn-f-c-c sn-pointer pagination-interaction" :class="{'pagination-actived': pageCount > 1}" @click="exchangePage('1');">上一页</div>
        <div>当前第&nbsp;&nbsp;<span class="sn-fc-main">{{ pageCount }}</span>&nbsp;&nbsp;页</div>
        <div class="sn-f-c-c sn-pointer pagination-interaction"
        :class="{'pagination-actived': isResult || !$sn.validate.empty($sn.format.group(recordInfo, perpetual.PAGINATION_SIZE)[pageCount])}" @click="exchangePage('2');">下一页</div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import Swagger from '@/common/utils/swagger';
import AppointmentMixin from '@/pages/appointment/appointment-mixin';

export default {
  mixins: [AppointmentMixin],
  data() {
    return {
      recordInfo: [],
      pageCount: 1,
      isResult: true,
      recordInterval: null
    };
  },
  computed: {
    handleRecord() {
      let handle = [];
      if (this.recordInfo.length > 0) {
        handle = this.$sn.format.group(this.recordInfo, this.perpetual.PAGINATION_SIZE)[this.pageCount - 1];
      }
      return handle;
    },
    handlePattern() {
      return (record) => {
        if (record.state === 2) return 'sn-fc-text6';
        else if (record.state === 1) {
          if ([1, 4, 5].includes(record.hosState)) return 'sn-fc-text6';
          else if ([0, 3].includes(record.hosState)) return 'sn-fc-main';
          else if ([2].includes(record.hosState)) return 'sn-fc-red1';
        }
        return '';
      };
    },
    handleStatus() {
      return (record) => {
        if (record.state === 2) return '已取消';
        else if (record.state === 1) {
          if (record.hosState === 5) return '已完成';
          else if (record.hosState === 4) return '院方停诊取消';
          else if (record.hosState === 3) return this.$sn.getConfig('signInLabel') + '成功';
          else if (record.hosState === 2) return '爽约';
          else if (record.hosState === 1) return '就诊完成';
          else if (record.hosState === 0) {
            if (record.isDopay === 0) {
              if (this.appointment_mixin_verifyPayPromptInteraction(record)) {
                let value = '待支付';
                if (this.appointment_mixin_verifyPayRestrictTimeCaption(record)) {
                  value += '&nbsp;(' + record.time + ')&nbsp;';
                }
                return value;
              }
              else return '已预约';
            }
            else if (record.isDopay === 1) return '已支付';
          }
        }
        return '';
      };
    }
  },
  watch: {
    pageCount: {
      handler: function(n, o) {
        if ((n >= o || this.$sn.validate.empty(o)) && this.$sn.validate.empty(this.$sn.format.group(this.recordInfo, this.perpetual.PAGINATION_SIZE)[n])) {
          this.getRecord();
        }
      },
      immediate: true
    }
  },
  created: function() {
    if (this.$sn.utils.getHospitalSessionStorage('Appointment_RecordInfo')) {
      this.$sn.utils.removeHospitalSessionStorage('Appointment_RecordInfo');
    }
  },
  methods: {
    getRecord() {
      if (this.isResult) {
        const params = {
          url: this.$sn.format.caption(Swagger.getAppointmentInfoByCondition, [this.$sn.utils.getPlatformType(), this.$sn.utils.getProjectType()]),
          method: 'POST',
          header: true,
          data: JSON.stringify({
            hosId: this.$sn.utils.getHospitalId(),
            page: this.pageCount - 1,
            size: this.perpetual.PAGINATION_SIZE,
            userId: this.$sn.utils.getOpenId()
          })
        };
        this.$sn.assembly.loading(true);
        this.$sn.utils.ordinaryRequest(params).then(result => {
          this.$sn.assembly.loading(false);
          if (result && result.code === 0 && result.data && result.data.length > 0) {
            this.isResult = result.data.length === this.perpetual.PAGINATION_SIZE;
            if (this.pageCount === 1) {
              this.recordInfo = result.data;
            }
            else {
              this.recordInfo = this.recordInfo.concat(result.data);
            }
            if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_YTS) {
              this.recordInfo.forEach(record => {
                if (record.schId.substring(0, 5) === '21353') record.doctorName = '儿童入园健康检查';
              });
            }
            this.formatRecordInterval();
          }
          else this.isResult = false;
        });
      }
    },
    formatRecordInterval() {
      if (this.restrictAppointmentRecordPayTime > 0 || this.restrictTodayRegisterRecordPayTime > 0) {
        if (this.recordInterval) {
          clearInterval(this.recordInterval);
        }
        for (let i = 0; i < this.recordInfo.length; i++) {
          if (this.recordInfo[i].state === 1 && this.recordInfo[i].hosState === 0 && this.recordInfo[i].candidateFlag !== '1') {
            if (this.recordInfo[i].isDopay === 0 && this.recordInfo[i].regFee && parseFloat(this.recordInfo[i].regFee) > 0) {
              if (this.recordInfo[i].patientCardId) {
                if ((this.recordInfo[i].isToday === 0 && this.restrictAppointmentRecordPayTime > 0) || (this.recordInfo[i].isToday === 1 && this.restrictTodayRegisterRecordPayTime > 0)) {
                  if (this.appointment_mixin_compareAppointmentRecordPayTime(this.recordInfo[i])) {
                    this.recordInterval = setInterval(() => {
                      this.recordInfo.forEach(el => {
                        if (el.state === 1 && el.hosState === 0 && el.candidateFlag !== '1') {
                          if (el.isDopay === 0 && el.regFee && parseFloat(el.regFee) > 0) {
                            if (el.patientCardId) {
                              if ((el.isToday === 0 && this.restrictAppointmentRecordPayTime > 0) || (el.isToday === 1 && this.restrictTodayRegisterRecordPayTime > 0)) {
                                if (this.appointment_mixin_compareAppointmentRecordPayTime(el)) {
                                  if (parseInt(new Date().getTime().toString().substring(0, 10)) - new Date(el.opTime).getTime() / 1000 < (el.isToday === 0 ? this.restrictAppointmentRecordPayTime : this.restrictTodayRegisterRecordPayTime)) {
                                    this.$set(el, 'time', '');
                                    let value = 0;
                                    if (parseInt(new Date().getTime().toString().substring(0, 10)) - new Date(el.opTime).getTime() / 1000 > 0) {
                                      value = parseInt(new Date().getTime().toString().substring(0, 10)) - new Date(el.opTime).getTime() / 1000;
                                    }
                                    this.appointment_mixin_formatTime((el.isToday === 0 ? this.restrictAppointmentRecordPayTime : this.restrictTodayRegisterRecordPayTime) - value, el);
                                  }
                                  else {
                                    el.state = 2;
                                  }
                                }
                              }
                            }
                          }
                        }
                      });
                    }, 1000);
                    break;
                  }
                }
              }
            }
          }
        }
      }
    },
    // 1：上一页；2：下一页
    exchangePage(type) {
      if (type === '1') {
        if (this.pageCount > 1) this.pageCount--;
      }
      else if (type === '2') {
        if (this.isResult || !this.$sn.validate.empty(this.$sn.format.group(this.recordInfo, this.perpetual.PAGINATION_SIZE)[this.pageCount])) this.pageCount++;
      }
    }
  },
  beforeDestroy() {
    if (this.recordInterval) {
      clearInterval(this.recordInterval);
    }
  }
};
</script>
<style lang="scss" scoped>
.record {
  overflow: hidden;
  width: 100%;
  height: 100%;

  &-region {
    overflow: hidden;
    height: 100%;

    .record-blank {
      overflow: hidden;
      width: 100%;
      padding: 20px 20px 0;
    }

    .pagination {
      @include fs(16);

      width: 100%;
      height: 40px;
      margin: 20px 0 40px;

      &-interaction {
        height: 40px;
        color: $text6;
        border: 1px solid $border1;
        border-radius: 5px;
        padding: 0 20px;
        margin: 0 10px;

        &:last-child {
          margin-right: 20px;
        }
      }

      &-actived {
        color: $text1;

        &:hover {
          background-color: $main4;
          color: $main3;
          border: 1px solid $main3;
        }
      }
    }
  }
}
</style>
